// Helper functions for ReservationNightTable
import { format, parse } from "date-fns"

export const formatDate = (dateString) => {
  if (!dateString) return ""

  // Parse YYYY-MM-DD date string without timezone conversion
  return format(parse(dateString, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
}

export const formatDateShort = (dateString) => {
  if (!dateString) return ""

  // Parse YYYY-MM-DD date string without timezone conversion
  return format(parse(dateString, "yyyy-MM-dd", new Date()), "MMM d")
}
